import React from "react";

function ChatgptResponse({ data }) {
  return (
    <div className="chatgpt-response section">
      <h2 className="otherhead">Base Model Comparison</h2>
      <div className="panel comparison-panel">
        {data ? (
          <pre>{data}</pre>
        ) : (
          <p></p>
        )}
      </div>
    </div>
  );
}

export default ChatgptResponse;
